import { TopbarRouteContent } from './topbar/topbarRegistry';
import { TopbarShell } from './topbar/TopbarShell';
import { useTopbarPortal } from './TopbarPortal';

export interface TopbarProps {
  /** Callback to toggle mobile sidebar */
  onMenuToggle?: () => void;
  /** Whether to show the mobile menu button */
  showMenuButton?: boolean;
  /** Additional class names */
  className?: string;
}

/**
 * Top navigation bar with search, user menu, and quick actions.
 *
 * Features:
 * - Semantic header element for accessibility
 * - Search input (placeholder for now)
 * - User dropdown menu with logout
 * - Quick actions area (notifications, help)
 * - Respects safe-area-inset for fixed positioning (ui-skills)
 *
 * @example
 * <Topbar onMenuToggle={toggleSidebar} showMenuButton={isMobile} />
 */
export function Topbar({ onMenuToggle, showMenuButton = false, className }: TopbarProps) {
  const { mode, setPortalNode } = useTopbarPortal();
  const portalMode = mode === 'portal';

  return (
    <TopbarShell
      portalMode={portalMode}
      showMenuButton={showMenuButton}
      onMenuToggle={onMenuToggle}
      className={className}
      setPortalNode={setPortalNode}
      content={<TopbarRouteContent />}
    />
  );
}
